import Axios from '@/axios';

// 查询商品
export const GetGoods = data => {
  return Axios({
    url: '/face/web/good/index_for_user',
    method: 'POST',
    type: 'json',
    data
  })
}
export const GetSmsGoods = data => {
  return Axios({
    url: '/face/web/good/index_for_user',
    method: 'POST',
    type: 'json',
    data
  })
}
// 创建设备订单
export const CreateDeviceOrder = data => {
  return Axios({
    url: '/face/web/good-order/create',
    method: 'POST',
    type: 'json',
    data
  })
}



// 创建商品订单
export const createUserOrder = data => {
  return Axios({
    url: '/face/web/good-order/create_user_good_order',
    method: 'POST',
    type: 'json',
    data
  })
}
// 创建订单
export const ShowPayState = id => {
  return Axios({
    url: `/face/web/good-order/show_pay_state/${id}`,
    method: 'POST',
    type: 'json'
  })
}

